import { Store } from 'antd/lib/form/interface';
import {
  formDiffs,
  momentizeObjectDates,
  replaceUndefinedWithNull,
} from '@core/utils/methods';
import {
  JurisdictionDetailsPermittingType,
  PermittingDetailsJurisdictionInfo,
  PermittingDetailsJurisdictionPermitting,
  PermittingDetailsJurisdictionZoning,
  PermittingJurisdictionAuditBody,
} from '@models/interfaces';

export const dataToBodyMapper = (
  [initialSummary, initialZoningFormData, initialPermitting]: Store[],
  [summary, zoningFormData, permitting]: Store[],
  jurisdictionId: string,
  permitTypeTableData: JurisdictionDetailsPermittingType[],
  zoningId?: string,
  permittingId?: string,
): PermittingJurisdictionAuditBody => {
  const summarySectionDifference = {
    ...formDiffs(initialSummary, summary),
    id: jurisdictionId,
  };

  const summaryData =
    'jurisdictionAuditComplete' in summarySectionDifference
      ? (momentizeObjectDates(
          summarySectionDifference,
          ['jurisdictionAuditComplete'],
          true,
        ) as unknown as PermittingDetailsJurisdictionInfo)
      : (summarySectionDifference as unknown as PermittingDetailsJurisdictionInfo);

  const proccessedSummary = replaceUndefinedWithNull(summaryData);

  return {
    summarySection: proccessedSummary,
    ...(zoningId
      ? {
          zoningSection: {
            ...formDiffs(initialZoningFormData, zoningFormData),
            id: zoningId,
          } as PermittingDetailsJurisdictionZoning,
        }
      : {}),
    ...(permittingId
      ? {
          permittingSection: {
            ...formDiffs(initialPermitting, permitting),
            id: permittingId,
            permitTypeTableData,
          } as PermittingDetailsJurisdictionPermitting,
        }
      : {}),
  };
};
